module.exports = __webpack_public_path__ + "img/button_info.d29ba1fb.svg";